export default __webpack_public_path__ + "static/media/TextLogo.02fd33a1.svg";